<template>
<div><AboutUsNav></AboutUsNav>
	<div style="width: 100%; overflow: unset;">
		<!-- <div class="banner">
			<div class="banner-span">
				<span style="color: #fff;font-size: 56px;">是人才，拍界就给你提供发展的平台</span>
			</div>
			<img src="../assets/images/20200714162810.jpg"/>
		</div> -->

		<div  class="CenTer">
			<!-- <div class="application">	
				<br><span class="f30">提交下方申请表，即刻成为合伙人。</span><br><br>
				<span class="f24">（填表前请悉知下方常见问题）</span>
			</div>
			<div class="address">	
				<el-button class="Ediately" style="width: 251px; height:69px;background-color: #fff;font-size: 17px; border-radius:7px; border: 1px solid #c71622" @click="dialogFormVisible = true"><span class="ediately" style="color: #c71622;font-size: 24px">立即申请</span>
				</el-button>
			</div> -->
			<!-- <el-dialog title="拍界合伙人申请" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				
				<el-form-item label="姓名">
					<el-input v-model="form.name" autocomplete="on"></el-input>
				
				</el-form-item>	
				<el-form-item label="年龄">
					<el-input v-model="form.age" autocomplete="on"></el-input>
				</el-form-item>	
				
				<el-form-item label="性别">
					<el-input v-model="form.sex" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="居住地址">
					<el-input v-model="form.address" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="电话">
					<el-input v-model="form.phone" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="电子邮件">
					<el-input v-model="form.email" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="毕业学校">
					<el-input v-model="form.school" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="学习专业">
					<el-input v-model="form.major" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="在校时间">
					<el-input v-model="form.school_at" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="工作经验">
					<el-input v-model="form.work" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="是否曾经创业">
					<el-input v-model="form.business" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="合作意向城市城市">
					<el-input v-model="form.city" autocomplete="on"></el-input>
				</el-form-item>

				<el-form-item label="资产情况">
					<el-input v-model="form.assets" autocomplete="on"></el-input>
				</el-form-item>

			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" style="width: 200px">取 消</el-button>
				<el-button type="primary" @click="Dialog" style="width: 200px" >确 定</el-button>
			</div>
		</el-dialog> -->
			<div class="business">
				<div class="business-join">
					<div class="join-title"><h5>招募合伙人</h5>来拍界成为合伙人吧，创业成功率高达95%！</div>
					<div class="join-summary">拍界正式开放合作渠道，招募城市合伙人<br>如果您符合拍界城市合伙人的要求<br>则您可以投资加入拍界，成为该城市的合伙人</div>
				</div>
					<div class="business-img1"><img src="../assets/images/ecommerce-2140604_1280.jpg" ></div>
			</div>
					
			<div class="Abusiness">
					<div class="business-img2"><img src="../assets/images/a9b49521023.jpg"></div>
					<div class="business-join2">
						<div class="Ajoin-title"><h5>拍卖新体验</h5>共筑梦想，与我同行</div>
						<div class="Ajoin-summary">正是有了拍界，才让更多的卖家、参拍者看到了曙光<br>拍界网完善的平台机制，让更多人从中看到了价值<br>好的平台成就好的企业，成就好的未来<br>在未来的发展道路上，不断探索平台功能性，给您最好的拍卖体验<br>拍卖无边界，拍卖更便捷，选择拍界，拍界等你！</div>
					</div>
			</div>	

			<!--<div class="Z" style="width: 100%;">
				<span style="font-size: 27px;">常见问题</span>
				<hr>
			</div>
			<div style="width: 100%;margin-top: 33px;">
				<div class="Lb">
						<div style="width: 141px;text-align:left;"><br><p style="font-size: 17px;font-weight: bold;">>关于合作模式&nbsp</p><br> </div>
						<div style="font-weight: bold;text-align:left;">>1、什么是拍界城市合伙人？</div><br>			
						<div style="text-align:left;" class="Bottom">"合伙人计划"是拍界开放的一种合伙创业方式，给希望进入<br/>拍卖业又担心独自创业风险过高的创业者提供一个创业平台，<br/>
						如您符合拍界合伙人招募标准，即可以与拍界合作，合伙人<br/>模式无需缴纳加盟费、品牌使用费等，拍界总部与合伙人收<br/>益共赢、风险共担。</div><br>
				<div style=";font-weight: bold;text-align:left;">>2、合作的基本条件</div><br>
				<div style="text-align:left;">（1）合伙人需要有独立的法人资格；<br>
				（2）合伙人需要认可拍界的市场前景；<br>
				（3）合伙人具有一定擅长点或某领域的专业型人才。</div><br>
				<div style="font-weight: bold;text-align:left;">>3、哪些城市可以合作？</div><br>
				<div style="text-align:left;">&nbsp&nbsp&nbsp&nbsp不包含长春市、直辖市和特别行政区</div><br>
				<div style="font-weight: bold;text-align:left;">>4、申请成为合伙人的流程？</div><br>
				<div style="text-align:left;" class="Bottom">拨打电话400-9005-905转2、15143049572，或于官网提交申请表如符合基本条件我<br/>们将于15个工作日内回访（若暂未通过初步审核，将不予一<br/>一回复，敬请谅解！）。</div><br>
				</div>
			</div> -->

		</div>	

	</div>
		
</div>
</template>
<script>
import qs from 'qs';
import AboutUsNav from '@/components/AboutUsNav.vue';
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	data (){
		return{
			form: {
				name: '',
				age: '',
				sex: '',
				address: '',
				phone: '',
				email: '',
				school: '',
				major: '',
				school_at: '',
				work: '',
				business: '',
				city: '',
				assets: ''

			},
			dialogFormVisible: false,
		}
	 },
	created(){
		// 显示公共栏
		// this.$emit('header', true)
		this.$emit('footer', true)


		// 页面至顶部
		window.scrollTo(0,0);
	},
	methods: {
		Dialog: function(){
			let dialogs = qs.stringify({

					name: this.form.name,
					age: this.form.age,
					sex: this.form.sex,
					address: this.form.address,
					phone: this.form.phone,
					email: this.form.email,
					school: this.form.school,
					major: this.form.major,
					school_at: this.form.school_at,
					work: this.form.work,
					business: this.form.business,
					city: this.form.city,
					assets: this.form.assets,

				})
			this.axios.post("https://api.paijie.com/partners/store", dialogs, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				})
				.then((response) => {
					if (response.data.error.code == 0){
						this.dialogFormVisible = false;
						this.$alert('提交成功', '提示', {
							confirmButtonText: '确定'
						})
					}
					else{

						console.log(response.data.error.message)
						this.$alert(response.data.error.message, '提示', {
							confirmButtonText: '确定'
						});
					}
				})
		}
	},
	mounted(){
		
	},
  components: {
    AboutUsNav
  }
}
</script>